import { Modal, ModalTitle, ModalBody, ModalFooter } from 'design-system/src/components/Modal';
import { Typography } from 'design-system/src/components/Typography/Typography';
import Button from 'design-system/src/components/Button/Button';

export type ReferralSuccessModalProps = {
  onClose: () => void;
  referredContactEmail: string;
};

/**
 * Modal with success message after a referral is submitted.
 */
export const ReferralSuccessModal = ({ onClose, referredContactEmail }: ReferralSuccessModalProps) => {
  return (
    <Modal onClose={onClose}>
      <ModalTitle>Thanks for the referral!</ModalTitle>
      <ModalBody>
        <Typography styledAs="bodyLargeDMSans">
          We've sent an email to <i>{referredContactEmail}</i> to help them get started on Tandem!
        </Typography>
      </ModalBody>
      <ModalFooter>
        <Button variant="secondary" to="/prescriptions">
          See Prescriptions
        </Button>
        <Button onClick={onClose}>Refer someone else</Button>
      </ModalFooter>
    </Modal>
  );
};

export default ReferralSuccessModal;
